import { create } from 'zustand';

interface TelemedicinaState {
  url: string | null;
  minimized: boolean;
  open: (url: string) => void;
  close: () => void;
  toggleMinimized: () => void;
}

export const useTelemedicinaStore = create<TelemedicinaState>((set) => ({
  url: null,
  minimized: false,
  open: (url) => set({ url, minimized: false }),
  close: () => set({ url: null, minimized: false }),
  toggleMinimized: () => set((state) => ({ minimized: !state.minimized })),
}));
